(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 600px 0px'}).observe(this);
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.isHomePages = window.location.pathname === '/';
      this.isHomePages && this.header.classList.add('scrollTop__style');
      const logoList = [...document.querySelector('.header__heading-link').children];
      this.whiteLogo = logoList[0];
      this.blackLogo = logoList[1];
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.isScrollMostTop = true;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop - this.currentScrollTop > 28 && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
        this.isScrollMostTop = false;
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          this.reveal && requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 22);

          requestAnimationFrame(this.hide.bind(this));
        }
        this.isScrollMostTop = false;
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
        this.isScrollMostTop = true;
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (typeof setHeaderHeight === 'function') setHeaderHeight();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (typeof setHeaderHeight === 'function') setHeaderHeight();
      this.isHomePages ? this.switchHeaderBarStyle() : this.switchHeaderLogo();
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (typeof setHeaderHeight === 'function') setHeaderHeight();
      this.isHomePages ? this.switchHeaderBarStyle() : this.switchHeaderLogo();
    }
    /** 切换header的样式 */
    switchHeaderBarStyle() {
      const isOpenAsideBar = document.querySelector('header-drawer summary').getAttribute('aria-expanded')
       || document.querySelector('cart-drawer summary').getAttribute('aria-expanded');
      if(!isOpenAsideBar && this.isScrollMostTop) {
        this.whiteLogo.classList.remove('small-hide');
        this.blackLogo?.classList.add('small-hide');
        this.header.classList.add('scrollTop__style');
      } else {
        this.whiteLogo.classList.add('small-hide');
        this.blackLogo?.classList.remove('small-hide');
        this.header.classList.remove('scrollTop__style');
      }
    }
    switchHeaderLogo() {
      this.whiteLogo.classList.add('small-hide');
      this.blackLogo?.classList.remove('small-hide');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }

        hide() {
          super.hide();
          window.pauseAllMedia();
        }

        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`).forEach(
            (element) => {
              element.classList.remove('active');
            }
          );
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
            activeMedia.loadContent();
        }
      }
    );
  }

  if (!customElements.get('accessory-add')) {
    customElements.define(
      'accessory-add',
      class AccessoryAdd extends HTMLElement {
        constructor() {
          super();
        }

        getAccessoryModalVariant() {
          const contentRoot = document.querySelector('.product-content .html-content');
          if (!contentRoot) return null;

          const variantPicker =
            contentRoot.querySelector('variant-radios[data-tplsuffix="accessory-modal"]') ||
            contentRoot.querySelector('variant-selects[data-tplsuffix="accessory-modal"]');
          if (variantPicker?.currentVariant) {
            return variantPicker.currentVariant;
          }

          const productDataEl = contentRoot.querySelector('#product_data');
          if (!productDataEl) return null;

          try {
            const productData = JSON.parse(productDataEl.textContent);
            return (
              productData.variants?.find((variant) => variant.available) ||
              productData.variants?.[0] ||
              null
            );
          } catch {
            return null;
          }
        }

        connectedCallback() {
          const id = Number(this.getAttribute('id'));
          const handle = this.getAttribute('handle');
          const addCartButton = this.querySelector('.select-item-button--add-cart');
          const selectAddonButton = this.querySelector('.select-item-button--select-addon');

          addCartButton?.addEventListener('click', () => {
            if (
              addCartButton.classList.contains('disabled') ||
              addCartButton.classList.contains('loading') ||
              addCartButton.hasAttribute('disabled')
            ) {
              return;
            }
            const variant = this.getAccessoryModalVariant();
            if (!variant?.available) return;
            this.addAccessoryToCart(id, addCartButton, variant);
          });

          selectAddonButton?.addEventListener('click', () => {
            if (selectAddonButton.classList.contains('disabled')) return;
            const variant = this.getAccessoryModalVariant();
            if (!variant?.available) return;

            const isSelected = selectAddonButton.classList.contains('selected');
            if (isSelected) {
              window.UniEventBus.submit('REMOVE_ACCESSORY_ITEM', { productId: id });
              return;
            }

            const imageUrl =
              typeof getVariantFeaturedImageSrc === 'function' ? getVariantFeaturedImageSrc(variant) : null;

            window.UniEventBus.submit('SELECT_ACCESSORY_ITEM', {
              productId: id,
              productHandle: handle,
              variantId: variant.id,
              variantPrice: variant.price / 100,
              sku: variant.sku,
              imageUrl,
            });
            this.closeAccessoryModal();
          });

          window.UniEventBus.on('UPDATE_SELECTED_ACCESSORIES', (data) => {
            const isSelected = data.map((item) => item.productId).includes(id);
            if (isSelected) {
              this.querySelector('.accessory-add-button')?.classList.add('selected');
              selectAddonButton?.classList.add('selected');
            } else {
              this.querySelector('.accessory-add-button')?.classList.remove('selected');
              selectAddonButton?.classList.remove('selected');
            }
          });
        }

        closeAccessoryModal(forceClose = false) {
          if (!forceClose && !window.matchMedia('(max-width: 749px)').matches) return;
          const modal = document.querySelector('accessories-sales modal-dialog');
          if (modal && typeof modal.hide === 'function') {
            modal.hide();
          }
        }

        openCartDrawer() {
          const miniCart = document.querySelector('mini-cart');
          if (miniCart && typeof miniCart.open === 'function') {
            miniCart.open();
            return;
          }
          const drawer = document.querySelector('cart-drawer');
          const summary = drawer?.querySelector('summary');
          summary?.click();
        }

        async addAccessoryToCart(productId, button, variant) {
          const resolvedVariant = variant || this.getAccessoryModalVariant();
          if (!resolvedVariant?.available) return;

          const miniCart = document.querySelector('mini-cart');
          button.classList.add('loading');
          button.setAttribute('aria-disabled', true);
          button.setAttribute('disabled', 'disabled');

          let cartCookieId = '';
          if (typeof window.__vernalSensorsEnsureCookieIdForCart === 'function') {
            cartCookieId = (await window.__vernalSensorsEnsureCookieIdForCart()) || '';
          } else if (typeof window.__vernalSensorsEnsurePresetPropertiesForCart === 'function') {
            await window.__vernalSensorsEnsurePresetPropertiesForCart();
            cartCookieId = typeof getCookie === 'function' ? getCookie('ver_sc_cid') || '' : '';
          } else {
            cartCookieId = typeof getCookie === 'function' ? getCookie('ver_sc_cid') || '' : '';
          }

          const sensorsPresetPayload =
            typeof window.__vernalSensorsGetPresetPropertiesForCart === 'function'
              ? window.__vernalSensorsGetPresetPropertiesForCart()
              : {};

          const properties = {
            _combineConfig: {
              combineId: typeof generateId === 'function' ? generateId() : String(Date.now()),
              combineType: 'product',
              itemType: 'accessories',
            },
            _version: window.commentPropertiesVersion,
            _productId: productId,
            _actualProductId: productId,
            _cookieId: cartCookieId,
            _skuId: +resolvedVariant.id,
            _productCombineId: typeof generateId === 'function' ? generateId() : String(Date.now()),
            _fulfillmentGroupId: typeof generateId === 'function' ? generateId() : String(Date.now()),
            ...sensorsPresetPayload,
          };

          const payload = {
            items: [
              {
                id: +resolvedVariant.id,
                quantity: 1,
                properties,
              },
            ],
          };

          if (miniCart) {
            payload.sections = miniCart.getSectionsToRender().map((section) => section.section);
          }
          payload.sections_url = window.location.pathname;

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                if (typeof BMessage !== 'undefined') {
                  BMessage.warning({ content: response.description, duration: 5 });
                }
                return;
              }
              this.closeAccessoryModal(true);
              if (miniCart && typeof miniCart.renderContents === 'function') {
                miniCart.renderContents(response);
              } else {
                this.openCartDrawer();
              }
            })
            .catch((e) => console.error(e))
            .finally(() => {
              button.classList.remove('loading');
              button.removeAttribute('aria-disabled');
              if (!button.classList.contains('disabled')) {
                button.removeAttribute('disabled');
              }
            });
        }
      }
    );
  }

  let headerRevealCache;
  // 是不是第一次进入页面
  let isFirstEnter = true;
  let isCeilingActive = false;
  // ceiling 激活前哨兵的文档坐标；激活后若布局仍收缩，不能再直接读 DOM
  let fixedPositionDocTop = null;

  const productFormArea = document.querySelector('product-form');
  const fixedPositionEl = document.querySelector('.fixed_position');
  const productInfoWrapper =
    document.getElementById('main-product-purchase') || document.querySelector('.product__info-wrapper');
  const productEl = productInfoWrapper?.closest('.product');

  function setCeilingTipsDisplay(wrapper, display) {
    if (wrapper.querySelector('.discount-code-tip-wrapper')) {
      wrapper.querySelector('.discount-code-tip-wrapper').style.display = display;
    }
    if (wrapper.querySelector('.collection-discount-code-tip-wrapper')) {
      wrapper.querySelector('.collection-discount-code-tip-wrapper').style.display = display;
    }
    if (wrapper.querySelector('.BF-product-countdown-wrapper')) {
      wrapper.querySelector('.BF-product-countdown-wrapper').style.display = display;
    }
  }

  function lockProductHeight() {
    if (!productEl || productEl.dataset.ceilingMinHeight) return;
    productEl.dataset.ceilingMinHeight = '1';
    productEl.style.minHeight = `${productEl.offsetHeight}px`;
  }

  function unlockProductHeight() {
    if (!productEl) return;
    productEl.style.minHeight = '';
    delete productEl.dataset.ceilingMinHeight;
  }

  function getFixedPositionRectY() {
    if (!fixedPositionEl) return null;
    if (isCeilingActive && fixedPositionDocTop != null) {
      return fixedPositionDocTop - window.scrollY;
    }
    return fixedPositionEl.getBoundingClientRect().y;
  }

  function applyCeiling(enable) {
    const header = document.querySelector('sticky-header');
    const productNavElList = document.querySelectorAll('.product_nav');
    if (!productInfoWrapper) return;

    if (enable) {
      if (isCeilingActive) return;
      if (fixedPositionEl) {
        fixedPositionDocTop = fixedPositionEl.getBoundingClientRect().top + window.scrollY;
      }
      // 先锁 .product 高度再让 info fixed，避免插入 grid 占位导致短暂撑高跳屏
      lockProductHeight();
      isCeilingActive = true;
      if (header) {
        if (header.reveal) {
          headerRevealCache = header.reveal;
        }
        header.hide();
        header.reveal = null;
      }
      productInfoWrapper.classList.add('ceiling', 'page-width');
      productNavElList?.[productNavElList.length - 1]?.classList?.remove('hidden');
      setCeilingTipsDisplay(productInfoWrapper, 'none');
    } else {
      if (!isCeilingActive && !productInfoWrapper.classList.contains('ceiling')) return;
      isCeilingActive = false;
      try {
        if (header && headerRevealCache) {
          header.reveal = headerRevealCache;
          header.reveal();
        }
      } catch (e) {
        // header.reveal 异常时仍需移除 ceiling，避免右侧信息区空白
      }
      productInfoWrapper.classList.remove('ceiling', 'page-width');
      unlockProductHeight();
      fixedPositionDocTop = null;
      productNavElList?.[productNavElList.length - 1]?.classList?.add('hidden');
      setCeilingTipsDisplay(productInfoWrapper, 'block');
    }
  }

  function syncCeiling(rectY) {
    if (window.innerWidth <= 750) {
      applyCeiling(false);
      return;
    }

    // 短页面加 ceiling 后文档变矮，滚回顶部时 IO 可能不触发；scrollY≈0 时强制移除
    // 滞回：激活用 rectY < 0，关闭需 rectY > 24，避免阈值附近反复切换跳屏
    const shouldShow =
      !isFirstEnter &&
      window.scrollY > 0 &&
      typeof rectY === 'number' &&
      (isCeilingActive ? rectY < 24 : rectY < 0);

    if (!shouldShow) {
      isFirstEnter = false;
    }
    applyCeiling(shouldShow);
  }

  function syncCeilingFromDom() {
    if (!fixedPositionEl) return;
    syncCeiling(getFixedPositionRectY());
  }

  const observer = new IntersectionObserver(function (entries) {
    // ceiling 激活后哨兵会随布局收缩上移，优先用缓存文档坐标判断
    syncCeiling(getFixedPositionRectY() ?? entries[0].boundingClientRect.y);
    requestAnimationFrame(syncCeilingFromDom);
  });

  if (window.innerWidth > 750 && fixedPositionEl) {
    observer.observe(fixedPositionEl);
  }

  /**
   * 防抖函数
   * @param {Function} fn 目标函数
   * @param {Number} delay 延迟时间（毫秒）
   */
  function debounce(fn, delay = 200) {
    let timer = null;
    return function(...args) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    };
  }

  window.addEventListener(
    'scroll',
    debounce(() => {
      if (window.innerWidth > 750) {
        syncCeilingFromDom();
      }
    }, 50),
    { passive: true }
  );

  window.addEventListener('resize', debounce(() => {
    if (!fixedPositionEl) return;
    if (window.innerWidth > 750) {
      observer.observe(fixedPositionEl);
      syncCeilingFromDom();
    } else {
      observer.unobserve(fixedPositionEl);
      applyCeiling(false);
    }
  }, 200));

  ondeviceorientation = (event) => {};

  // 商详悬浮顶部导航栏
  document.addEventListener('DOMContentLoaded', function () {
    const navLinks = document.querySelectorAll('.fixed-tabs__links-item');

    const observerOptions = {
      root: null,
      rootMargin: '-20% 0px -79% 0px', // 调整可见区域的范围
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute('id');
        const link = document.querySelector(`.fixed-tabs__links-item[data-section-id="${id}"]`);

        if (entry.isIntersecting) {
          // 移除所有链接的active类
          navLinks.forEach((link) => link.classList.remove('active'));
          // 给当前可见区域对应的链接添加active类
          link?.classList.add('active');
        } else {
          link?.classList.remove('active');
        }
      });
    }, observerOptions);

    // 观察所有内容区域
    navLinks.forEach((link) => {
      const sectionId = link.getAttribute('data-section-id');
      const section = document.getElementById(sectionId);
      if (section) {
        observer.observe(section);
      } else {
        link.style.display = 'none';
        // console.error(`Section with ID ${sectionId} not found`);
      }
    });

    // 点击导航链接时平滑滚动
    navLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const sectionId = link.getAttribute('data-section-id');
        const dataBlock = link.getAttribute('data-block');

        const section = document.getElementById(sectionId);

        if(!section) return;
   
        if (dataBlock) {
          scrollToElementBottom(section, 0);
          return;
        }

        section?.scrollIntoView({
          behavior: 'smooth',
        });
      });
    });
  });

  function scrollToElementBottom(element, extraOffset = 0) {
    const rect = element.getBoundingClientRect();
    const elementTop = rect.top + window.pageYOffset;
    const elementHeight = rect.height;
    
    // 计算元素底部的位置，减去额外偏移
    const elementBottomPosition = elementTop + elementHeight - extraOffset;
    
    window.scrollTo({
      top: elementBottomPosition,
      behavior: 'smooth'
    });
  }

  // 评论移动到商品标题底部
  document.addEventListener('DOMContentLoaded', function () {
    const yotpoCustomAppBox = document.querySelector('#yotpo-custom-app-box');
    if (yotpoCustomAppBox) {
      const yotpoCustomApp = document.querySelector('#yotpo-custom-app');
      if(!yotpoCustomApp) return;
      yotpoCustomAppBox.innerHTML = '';
      yotpoCustomAppBox.appendChild(yotpoCustomApp);
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 600px 0px'}).observe(this);
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scene-of-vernal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sceneOfVernal = document.querySelectorAll('.scene-of-vernal');
    sceneOfVernal.forEach((sceneOfVernalItem) => {
      const sectionId = sceneOfVernalItem.dataset.sectionId;
      const tabItems = sceneOfVernalItem.querySelectorAll(`.tab-item-scenebutton`);
      const tabContents = sceneOfVernalItem.querySelectorAll(`.tab-content-item-${sectionId}`);

      const preloadTabImages = () => {
        sceneOfVernalItem.querySelectorAll('.tab-content img[src]').forEach((img) => {
          if (img.dataset.preloaded || img.complete) return;
          img.dataset.preloaded = 'true';
          const preloader = new Image();
          if (img.srcset) preloader.srcset = img.srcset;
          if (img.sizes) preloader.sizes = img.sizes;
          preloader.src = img.currentSrc || img.src;
        });
      };

      if (typeof theme !== 'undefined' && theme.initWhenVisible) {
        theme.initWhenVisible({
          element: sceneOfVernalItem,
          callback: preloadTabImages,
          threshold: 200,
        });
      } else {
        preloadTabImages();
      }

      tabItems.forEach((tabItem, index) => {
        tabItem.addEventListener('click', function() {
          tabItems.forEach((item) => item.classList.remove('tab-item--active'));
          tabContents.forEach((item) => item.classList.remove('tab-content-item--active'));

          tabItem.classList.add('tab-item--active');
          tabContents[index].classList.add('tab-content-item--active');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order-status"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const trackOrderSection = document.querySelector('.track-order-status');

    /**
     * 将ISO格式的日期时间字符串切分为日期和时间两部分
     * @param {string} isoDateTime - ISO格式的日期时间字符串，如'2025-11-26T13:14:00+01:00'
     * @returns {Object} 包含日期和时间的对象，格式为{date: 'YYYY-MM-DD', time: 'HH:MM'}
     */
    function splitDateTime(isoDateTime) {
      if (!isoDateTime || typeof isoDateTime !== 'string') {
        return { date: '', time: '' };
      }

      const value = isoDateTime.trim();

      if (value.includes('T')) {
        const parts = value.split('T');
        return {
          date: parts[0] || '',
          time: parts[1] ? parts[1].substring(0, 5) : '',
        };
      }

      const normalized = value.replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
      const parts = normalized.split(' ');

      return {
        date: parts[0] || value,
        time: parts[1] ? parts[1].substring(0, 5) : '',
      };
    }

    // 分割产品名称和变体信息的函数
    function splitProductNameAndVariant(fullName) {
      // 检查输入是否有效
      if (!fullName || typeof fullName !== 'string') {
        return { productName: '', variant: '' };
      }

      // 使用" - "作为分隔符
      const separator = ' - ';
      const separatorIndex = fullName.indexOf(separator);

      if (separatorIndex === -1) {
        // 如果没有分隔符，整个字符串作为产品名称
        return { productName: fullName.trim(), variant: '' };
      }

      // 分割字符串
      const productName = fullName.substring(0, separatorIndex).trim();
      const variant = fullName.substring(separatorIndex + separator.length).trim();

      return { productName, variant };
    }

    // 提取参数中最后一个斜杠后面的数字
    function extractNumberFromOrderName(orderName) {
      if (!orderName || typeof orderName !== 'string') {
        return '';
      }

      // 使用split()方法将字符串分割成数组
      const parts = orderName.split('/');

      // 取最后一个元素
      const lastPart = parts[parts.length - 1];

      // 检查是否为数字
      if (/^\d+$/.test(lastPart)) {
        return lastPart;
      }

      return '';
    }

    let updateLoading = false;

    const vernalShopIdMap = {
      us: '132711809701380096',
      uk: 'vernal_uk',
      de: '59150808876318720',
      jp: 'vernal_jp',
      test: 'test',
    };
    // TODO
    const baseURL = 'https://api.fezibo.com/ugc'; // 正式环境
    // const baseURL = 'https://scm-app-test.youniverse.cc/ugc'; // 测试环境
    const baseURL2 = 'https://scm-app.youniverse.cc'; // 正式环境
    // const baseURL2 = 'https://scm-app-test.youniverse.cc'; // 测试环境
    let ShopKey = window.shop_country;

    const trackOrderForm = document.getElementById('track-order-form');
    const orderNumberInput = document.getElementById('order-number');
    const emailInput = document.getElementById('email');

    // 解析URL参数并自动填充表单
    function autoFillAndSubmitForm() {
      const urlParams = new URLSearchParams(window.location.search);
      const orderName = urlParams.get('order_name');
      const email = urlParams.get('email');
      const preOrderName = urlParams.get('pre_order_name');

      if (orderName && email) {
        // 填充表单字段
        orderNumberInput.value = orderName;
        emailInput.value = email;

        // 自动提交表单
        trackOrderForm.dispatchEvent(new Event('submit'));
      }

      if (preOrderName && email) {
        // 提取订单号中的数字
        const orderNumber = extractNumberFromOrderName(preOrderName);

        if (orderNumber) {
          // 填充表单字段
          const shopId = vernalShopIdMap[ShopKey] ?? '132711809701380096';
          // TODO
          // const shopId = 'test';
          const requestPre = `${baseURL}/order/detail/getOrderById?shopId=${shopId}&orderId=gid://shopify/Order/${orderNumber}`;
          fetch(requestPre)
            .then((response) => response.json())
            .then((res) => {
              const { code, data } = res;
              if (code === 0 && data && data.name) {
                orderNumberInput.value = data.name;
                emailInput.value = email;
                // 自动提交表单
                trackOrderForm.dispatchEvent(new Event('submit'));
              }
            });
        }
      }
    }

    // 保留label的方法
    function keepLabel(element, newText) {
      const labelElement = element.querySelector('.label');
      const skuMarkElement = element.querySelector('.track-tooltip');
      if (labelElement) {
        // 保留标签，只更新后面的内容
        const textNode = document.createTextNode(` ${newText}`);
        element.innerHTML = '';
        element.appendChild(labelElement);
        element.appendChild(textNode);
      }
      if (skuMarkElement) {
        element.appendChild(skuMarkElement);
      }
    }

    // 获取 multilingual-data 上的data数据
    const multilingualData = document.querySelector('.multilingual-data');
    const dataAttributes = multilingualData.dataset;

    const packageStatusEnum = {
      1: 'Pending Shipment',
      2: 'Shipped',
      3: 'Intransit',
      4: 'Out for Delivery',
      5: 'Delivered',
    };

    function setPackageFilterToggleEnabled(type, enabled) {
      const toggle = getPackageFilterDropdown(type)?.querySelector('.track-order-status__filter-dropdown-toggle');

      if (!toggle) {
        return;
      }

      toggle.classList.toggle('is-disabled', !enabled);
      toggle.setAttribute('aria-disabled', enabled ? 'false' : 'true');

      if (enabled) {
        toggle.removeAttribute('disabled');
      } else {
        toggle.setAttribute('disabled', 'disabled');
      }
    }

    function collectPackageFilterOptionsFromResult(result) {
      const statusSet = new Set();
      const shippingSet = new Set();
      let packageCount = 0;

      (result?.items || []).forEach((item) => {
        (item?.packageItemBOS || []).forEach((packageItem) => {
          packageCount += 1;

          const status = resolvePackageStatus(packageItem);
          const shipping = resolvePackageShippingMethod(packageItem);

          if (status) {
            statusSet.add(status);
          }

          if (shipping) {
            shippingSet.add(shipping);
          }
        });
      });

      return { statusSet, shippingSet, packageCount };
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function escapeFilterAttr(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function normalizePackageStatusString(status) {
      const value = String(status).trim();
      const lower = value.toLowerCase();
      const aliases = {
        'pending shipment': packageStatusEnum[1],
        shipped: packageStatusEnum[2],
        intransit: packageStatusEnum[3],
        'in transit': packageStatusEnum[3],
        'out for delivery': packageStatusEnum[4],
        delivered: packageStatusEnum[5],
      };

      if (aliases[lower]) {
        return aliases[lower];
      }

      const enumMatch = Object.values(packageStatusEnum).find((enumStatus) => enumStatus.toLowerCase() === lower);

      return enumMatch || value;
    }

    function mergeShopifyMetaProductVO(existing, incoming) {
      if (!incoming?.sellerOrderId) {
        return existing || {};
      }

      if (!existing?.sellerOrderId) {
        return incoming;
      }

      const merged = { ...incoming };
      const existingItems = existing.items || [];
      const incomingItems = incoming.items || [];
      const maxItemLength = Math.max(existingItems.length, incomingItems.length);
      const mergedItems = [];

      for (let index = 0; index < maxItemLength; index += 1) {
        const existingItem = existingItems[index];
        const incomingItem = incomingItems[index];

        if (!existingItem) {
          mergedItems.push(incomingItem);
          continue;
        }

        if (!incomingItem) {
          mergedItems.push(existingItem);
          continue;
        }

        const existingPackages = existingItem.packageItemBOS || [];
        const incomingPackages = incomingItem.packageItemBOS || [];

        mergedItems.push({
          ...incomingItem,
          ...existingItem,
          productImg: incomingItem.productImg || existingItem.productImg,
          productName: incomingItem.productName || existingItem.productName,
          quantity: incomingItem.quantity || existingItem.quantity,
          productOptionName: incomingItem.productOptionName || existingItem.productOptionName,
          productNumberOfBoxes: incomingItem.productNumberOfBoxes || existingItem.productNumberOfBoxes,
          packageItemBOS: existingPackages.length >= incomingPackages.length ? existingPackages : incomingPackages,
        });
      }

      merged.items = mergedItems;
      return merged;
    }

    function countPackagesInVO(vo) {
      return (vo?.items || []).reduce((count, item) => count + (item?.packageItemBOS?.length || 0), 0);
    }

    function buildShopifyMetaProductVO(mainRes, secondaryRes) {
      const hasMainOrder = mainRes?.code === 0;
      const secondaryVO = secondaryRes?.data || {};
      const hasSecondaryOrder = String(secondaryRes?.code) === '10000' && secondaryVO?.sellerOrderId;
      const mainVO = hasMainOrder ? mainRes.data?.shopifyMetaProductVO || mainRes.data || {} : {};

      if (hasSecondaryOrder && countPackagesInVO(secondaryVO) > 0) {
        return mergeShopifyMetaProductVO(mainVO, secondaryVO);
      }

      if (hasMainOrder && mainVO?.sellerOrderId) {
        return mergeShopifyMetaProductVO({}, mainVO);
      }

      if (hasSecondaryOrder) {
        return secondaryVO;
      }

      return {};
    }

    function resolvePackageStatus(packageItem) {
      let status = packageItem?.status ?? packageItem?.trackingInfo?.status;

      if (status === null || status === undefined || status === '') {
        return packageStatusEnum[1];
      }

      const numericStatus = Number(status);

      if (!Number.isNaN(numericStatus) && packageStatusEnum[numericStatus]) {
        return packageStatusEnum[numericStatus];
      }

      return normalizePackageStatusString(status);
    }

    function resolvePackageShippingMethod(packageItem) {
      const shippingMethod = String(packageItem?.shippingMethod || packageItem?.trackingInfo?.trackingCompany || '').trim();

      if (!shippingMethod || shippingMethod === '-') {
        return '';
      }

      return shippingMethod;
    }

    function getPackageFilterStatus(packageItemElement) {
      return packageItemElement.getAttribute('data-package-status') || '';
    }

    function getPackageFilterShippingMethod(packageItemElement) {
      return packageItemElement.getAttribute('data-package-shipping-method') || '';
    }

    function getTranslatedPackageStatus(status) {
      switch (status) {
        case packageStatusEnum[1]:
          return dataAttributes.pendingShipment;
        case packageStatusEnum[2]:
          return dataAttributes.shipped;
        case packageStatusEnum[3]:
          return dataAttributes.inTransit;
        case packageStatusEnum[4]:
          return dataAttributes.outForDelivery;
        case packageStatusEnum[5]:
          return dataAttributes.delivered;
        default:
          return status;
      }
    }

    function getPackageFilterDropdown(type) {
      return document.querySelector(`[data-package-filter="${type}"]`);
    }

    function getPackageFilterValue(type) {
      const dropdown = getPackageFilterDropdown(type);
      return dropdown?.dataset.value ?? '';
    }

    function setPackageFilterValue(type, value, label) {
      const dropdown = getPackageFilterDropdown(type);

      if (!dropdown) {
        return;
      }

      dropdown.dataset.value = value;

      const titleElement = dropdown.querySelector('.track-order-status__filter-dropdown-title');
      const defaultTitle = dropdown.dataset.filterTitle || '';

      if (titleElement) {
        titleElement.textContent = value ? label || value : defaultTitle;
      }

      dropdown.querySelectorAll('.track-order-status__filter-dropdown-option').forEach((option) => {
        const isSelected = option.dataset.value === value;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    }

    function closePackageFilterDropdowns(exceptType) {
      document.querySelectorAll('.track-order-status__filter-dropdown').forEach((dropdown) => {
        if (exceptType && dropdown.dataset.packageFilter === exceptType) {
          return;
        }

        dropdown.classList.remove('is-open');

        const toggle = dropdown.querySelector('.track-order-status__filter-dropdown-toggle');
        const menu = dropdown.querySelector('.track-order-status__filter-dropdown-menu');

        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        }

        if (menu) {
          menu.hidden = true;
        }
      });
    }

    function populatePackageFilterDropdown(type, options) {
      const dropdown = getPackageFilterDropdown(type);

      if (!dropdown) {
        return;
      }

      const menu = dropdown.querySelector('.track-order-status__filter-dropdown-menu');
      const toggle = dropdown.querySelector('.track-order-status__filter-dropdown-toggle');

      if (!menu || !toggle) {
        return;
      }

      menu.innerHTML = '';

      options.forEach(({ value, label }) => {
        const option = document.createElement('li');
        option.className = 'track-order-status__filter-dropdown-option';
        option.dataset.value = value;
        option.setAttribute('role', 'option');
        option.textContent = label;
        menu.appendChild(option);
      });

      const defaultOption = options[0] || { value: '', label: '' };
      setPackageFilterValue(type, defaultOption.value);
      setPackageFilterToggleEnabled(type, options.length > 1);
      closePackageFilterDropdowns();
    }

    function initPackageFilterDropdownEvents() {
      if (!trackOrderSection || trackOrderSection.dataset.packageFiltersBound === 'true') {
        return;
      }

      trackOrderSection.addEventListener('click', (event) => {
        const toggle = event.target.closest('.track-order-status__filter-dropdown-toggle');

        if (toggle) {
          event.preventDefault();
          event.stopPropagation();

          if (toggle.disabled || toggle.classList.contains('is-disabled')) {
            return;
          }

          const dropdown = toggle.closest('.track-order-status__filter-dropdown');
          const menu = dropdown?.querySelector('.track-order-status__filter-dropdown-menu');
          const isOpen = dropdown?.classList.contains('is-open');

          closePackageFilterDropdowns();

          if (!isOpen && dropdown && menu) {
            dropdown.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
            menu.hidden = false;
          }

          return;
        }

        const option = event.target.closest('.track-order-status__filter-dropdown-option');

        if (option) {
          event.preventDefault();
          event.stopPropagation();

          const dropdown = option.closest('.track-order-status__filter-dropdown');
          const type = dropdown?.dataset.packageFilter;

          if (!type) {
            return;
          }

          setPackageFilterValue(type, option.dataset.value, option.textContent);
          closePackageFilterDropdowns();
          applyPackageFilters();
          return;
        }

        if (!event.target.closest('.track-order-status__filter-dropdown')) {
          closePackageFilterDropdowns();
        }
      });

      trackOrderSection.dataset.packageFiltersBound = 'true';
    }

    function resetPackageFilters() {
      const statusFilter = document.querySelector('[data-filter-type="status"]');
      const shippingFilter = document.querySelector('[data-filter-type="shipping-method"]');

      ['status', 'shipping-method'].forEach((type) => {
        const dropdown = getPackageFilterDropdown(type);
        const toggle = dropdown?.querySelector('.track-order-status__filter-dropdown-toggle');
        const menu = dropdown?.querySelector('.track-order-status__filter-dropdown-menu');
        const titleElement = dropdown?.querySelector('.track-order-status__filter-dropdown-title');
        const defaultTitle = dropdown?.dataset.filterTitle || '';

        if (dropdown) {
          dropdown.dataset.value = '';
          dropdown.classList.remove('is-open');
        }

        if (titleElement) {
          titleElement.textContent = defaultTitle;
        }

        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        }

        if (menu) {
          menu.innerHTML = '';
          menu.hidden = true;
        }
      });

      if (statusFilter) {
        statusFilter.style.display = '';
      }

      if (shippingFilter) {
        shippingFilter.style.display = '';
      }

      closePackageFilterDropdowns();

      document.querySelectorAll('.is-filtered-hidden').forEach((element) => {
        element.classList.remove('is-filtered-hidden');
      });
    }

    function applyPackageFilters() {
      const statusVal = getPackageFilterValue('status');
      const shippingVal = getPackageFilterValue('shipping-method');

      document.querySelectorAll('.status-item__content-package-item').forEach((packageItem) => {
        const itemStatus = getPackageFilterStatus(packageItem);
        const itemShipping = getPackageFilterShippingMethod(packageItem);
        const statusMatch = !statusVal || itemStatus === statusVal;
        const shippingMatch = !shippingVal || itemShipping === shippingVal;

        if (statusMatch && shippingMatch) {
          packageItem.classList.remove('is-filtered-hidden');
        } else {
          packageItem.classList.add('is-filtered-hidden');
        }
      });

      document.querySelectorAll('.status-item').forEach((statusItem) => {
        const visiblePackages = statusItem.querySelectorAll('.status-item__content-package-item:not(.is-filtered-hidden)');

        if (visiblePackages.length === 0) {
          statusItem.classList.add('is-filtered-hidden');
        } else {
          statusItem.classList.remove('is-filtered-hidden');
        }
      });
    }

    function initPackageFilters(result) {
      const statusFilter = document.querySelector('[data-filter-type="status"]');
      const shippingFilter = document.querySelector('[data-filter-type="shipping-method"]');
      const statusDropdown = getPackageFilterDropdown('status');
      const shippingDropdown = getPackageFilterDropdown('shipping-method');
      const statusToggle = statusDropdown?.querySelector('.track-order-status__filter-dropdown-toggle');
      const shippingToggle = shippingDropdown?.querySelector('.track-order-status__filter-dropdown-toggle');

      if (!statusDropdown || !shippingDropdown || !statusToggle || !shippingToggle) {
        return;
      }

      const { statusSet, shippingSet, packageCount } = collectPackageFilterOptionsFromResult(result);
      const domPackageCount = document.querySelectorAll('.status-item__content-package-item').length;
      const hasPackageItems = packageCount > 0 || domPackageCount > 0;

      if (!hasPackageItems) {
        resetPackageFilters();
        setPackageFilterToggleEnabled('status', false);
        setPackageFilterToggleEnabled('shipping-method', false);
        return;
      }

      if (statusSet.size === 0 && domPackageCount > 0) {
        document.querySelectorAll('.status-item__content-package-item').forEach((packageItem) => {
          const itemStatus = getPackageFilterStatus(packageItem);
          const itemShipping = getPackageFilterShippingMethod(packageItem);

          if (itemStatus) {
            statusSet.add(itemStatus);
          }

          if (itemShipping) {
            shippingSet.add(itemShipping);
          }
        });
      }

      const allText = dataAttributes.filterAll || 'All';

      populatePackageFilterDropdown('status', [
        { value: '', label: allText },
        ...Array.from(statusSet)
          .sort()
          .map((status) => ({
            value: status,
            label: getTranslatedPackageStatus(status),
          })),
      ]);

      populatePackageFilterDropdown('shipping-method', [
        { value: '', label: allText },
        ...Array.from(shippingSet)
          .sort()
          .map((method) => ({
            value: method,
            label: method,
          })),
      ]);

      const hasStatusOptions = statusSet.size > 0;
      const hasShippingOptions = shippingSet.size > 0;

      if (statusFilter) {
        statusFilter.style.display = hasStatusOptions ? '' : 'none';
      }

      if (shippingFilter) {
        shippingFilter.style.display = hasShippingOptions ? '' : 'none';
      }

      setPackageFilterToggleEnabled('status', hasStatusOptions);
      setPackageFilterToggleEnabled('shipping-method', hasShippingOptions);

      initPackageFilterDropdownEvents();
      applyPackageFilters();
    }

    // 更新页面内容函数
    function updateResultContent(result) {
      // 更新订单号标题
      const orderTitleElement = document.querySelector('.track-seller-order-id');
      if (orderTitleElement) {
        orderTitleElement.textContent = result.sellerOrderId;
      }

      // 包裹信息
      const resultDescriptionElement = document.querySelector('.track-order-status__result-description');
      // 修改 包裹信息 是否有包裹信息
      if (resultDescriptionElement) {
        if (!result.sellerOrderId) {
          // 说明没有包裹信息
          // 隐藏包裹信息
          resultDescriptionElement.style.display = 'none';
        } else {
          // 说明有包裹信息
          // 显示包裹信息
          resultDescriptionElement.style.display = 'flex';
        }
      }

      // 更新邮件 日期 地址
      const orderEmailElement = document.querySelector('.track-order-status__result-description-email p:nth-child(1)');
      const orderDateElement = document.querySelector('.track-order-status__result-description-email p:nth-child(2)');
      const shippingAddressElement = document.querySelector('.track-order-status__result-description-email p:nth-child(3)');
      if (orderEmailElement) {
        // 保留原有标签，只更新邮箱地址
        keepLabel(orderEmailElement, result.buyerEmail);
      }

      if (orderDateElement) {
        // 保留原有标签，只更新日期
        keepLabel(orderDateElement, result.orderDate);
      }

      if (shippingAddressElement) {
        // 保留原有标签，只更新地址
        keepLabel(shippingAddressElement, result.shippingAddress);
      }

      // 更新订单状态
      const orderStatusElement = document.querySelector('.track-order-status__result-description-status p:nth-child(1)');
      if (orderStatusElement) {
        // 保留原有标签，只更新状态

        // result.orderStatus 要处理一下多语言

        //订单汇总状态
        // PENDING_SHIPMENT("Pending Shipment"),
        // PARTIALLY_SHIPPED("Partially Shipped"),
        // SHIPPED("Shipped"),
        // PARTIALLY_DELIVERED("Partially Delivered"),
        // DELIVERED("Delivered"),
        // ;
        // // 包裹状态轨迹枚举
        // PendingShipment("Pending Shipment", "Pending Shipment"),
        // Shipped("Shipped", "Shipped"),
        // InTransit("Intransit", "Intransit"),
        // OutForDelivery("Out for Delivery", "Out for Delivery"),
        // Delivered("Delivered", "Delivered");

        const orderStatusEnum = {
          1: 'Pending Shipment',
          2: 'Partially Shipped',
          3: 'Shipped',
          4: 'Partially Delivered',
          5: 'Delivered',
        };

        let orderStatusStatus = '';
        switch (result.orderStatus) {
          case orderStatusEnum[1]:
            orderStatusStatus = dataAttributes.pendingShipment;
            break;
          case orderStatusEnum[2]:
            orderStatusStatus = dataAttributes.partiallyShipped;
            break;
          case orderStatusEnum[3]:
            orderStatusStatus = dataAttributes.shipped;
            break;
          case orderStatusEnum[4]:
            orderStatusStatus = dataAttributes.partiallyDelivered;
            break;
          case orderStatusEnum[5]:
            orderStatusStatus = dataAttributes.delivered;
            break;
          default:
            orderStatusStatus = result.orderStatus;
            break;
        }

        keepLabel(orderStatusElement, orderStatusStatus);
      }

      const deliveriesContainerElement = document.querySelector('.track-order-status__result-description-status-deliveries');
      // 修改 包裹信息 是否有包裹信息
      if (deliveriesContainerElement) {
        if (result.noDelivery) {
          // 说明没有包裹信息
          // 隐藏包裹信息
          deliveriesContainerElement.style.display = 'none';
        } else {
          // 说明有包裹信息
          // 显示包裹信息
          deliveriesContainerElement.style.display = 'flex';
        }
      }
      const deliveries1Element = document.querySelector('.track-order-status__result-description-status-deliveries p:nth-child(1)');
      const deliveries2Element = document.querySelector('.track-order-status__result-description-status-deliveries p:nth-child(2)');
      const deliveries3Element = document.querySelector('.track-order-status__result-description-status-deliveries p:nth-child(3)');
      const deliveries4Element = document.querySelector('.track-order-status__result-description-status-deliveries p:nth-child(4)');
      const deliveries5Element = document.querySelector('.track-order-status__result-description-status-deliveries p:nth-child(5)');
      if (deliveries1Element) {
        // 保留原有标签，只更新包裹数
        keepLabel(deliveries1Element, result.deliveryBatch);
        keepLabel(deliveries2Element, result.totalNumberOfBoxes);
        keepLabel(deliveries3Element, result.numberOfBoxesPendingShipment);
        keepLabel(deliveries4Element, result.numberOfBoxesShipped);
        keepLabel(deliveries5Element, result.numberOfBoxesDelivered);
      }

      // result.items map status-item 把数据渲染到 status-item 中
      const statusItemsContainer = document.querySelector('.track-order-status__result-item-status-content');
      resetPackageFilters();

      if (statusItemsContainer && result.items && result.items.length > 0) {
        // 清空现有内容
        statusItemsContainer.innerHTML = '';

        // 遍历items数组
        result.items.forEach((item, index) => {
          try {
          // 创建status-item元素
          const statusItem = document.createElement('div');
          statusItem.className = 'status-item';

          // 构建商品信息部分
          let itemHtml = `
            <div class='status-item__content-product'>
              <div class='status-item__content-product-image-info'>
                <div class='status-item__content-product-image'>
                 ${
                   item.productImg
                     ? `<img
                    width='68'
                    height='68'
                    src='${item.productImg || ''}'
                    alt='${item.productName || 'Product'}'
                  >`
                     : ''
                 }
                </div>
                <div class='status-item__content-product-info'>
                  ${
                    item.productNumberOfBoxes
                      ? `<p class='number-of-boxes'>
                    <span class='label'>${dataAttributes.numberOfBoxes}: ${item.productNumberOfBoxes || 0} </span> 
                  </p>`
                      : ''
                  }
                  <p class='product-name'>${escapeHtml(item.productName)} x${item.quantity || 1}</p>
                  <p class='product-option'>${escapeHtml(item.productOptionName || '')}</p>
                </div>
              </div>
              <div class='status-item__content-product-svg'>
                <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40' fill='none'>
                  <rect x="1.74846e-06" y="40" width="40" height="40" rx="4" transform="rotate(-90 1.74846e-06 40)" fill="#173317"/>
                  <path d="M9.96988 12.4116L19.9433 24.7007L30.0644 12.4912C30.5088 11.9493 31.2311 11.9512 31.6774 12.4953C32.1237 13.0396 32.1252 13.92 31.5668 14.4617L20.8839 27.4861C20.7226 27.6618 20.5321 27.8637 20.4292 27.8971C20.0098 28.1029 19.4945 27.9999 19.0709 27.5883L8.23872 14.3819C7.90475 13.8355 7.90301 12.951 8.34948 12.4067C8.79586 11.8626 9.52134 11.8647 9.96985 12.4115L9.96988 12.4116Z" fill="white"/>
                </svg>
              </div>
            </div>
            <div class='status-item__content-package'>
             ${result.noDelivery ? `<div class='status-item__content-package-info'>${dataAttributes.packageInfo}</div>` : ''} 
          `;

          const statusEnum = {
            1: 'Pending Shipment',
            2: 'Shipped',
            3: 'Intransit',
            4: 'Out for Delivery',
            5: 'Delivered',
          };

          // 处理包裹信息
          if (item.packageItemBOS && item.packageItemBOS.length > 0) {
            const _packageItemBOS = [];
            item?.packageItemBOS?.forEach((packageItem, index) => {
              const { packageSort } = packageItem;

              //包裹属性
              // DESKTOP("Desktop"),
              // FRAME("Frame"),
              // PART("Part"),
              const packageTypeEnum = {
                DESKTOP: 'Desktop',
                FRAME: 'Frame',
                PART: 'Part',
              };

              // packageItem.productStyleName 处理一下多语言
              switch (packageItem.productStyleName) {
                case packageTypeEnum.DESKTOP:
                  packageItem.productStyleName = dataAttributes.desktop;
                  break;
                case packageTypeEnum.FRAME:
                  packageItem.productStyleName = dataAttributes.frame;
                  break;
                case packageTypeEnum.PART:
                  packageItem.productStyleName = dataAttributes.part;
                  break;
                default:
                  break;
              }

              if (packageSort >= 1 && packageItem?.productStyleName?.indexOf?.(dataAttributes.box) === -1) {
                packageItem.productStyleName = packageItem.productStyleName + ` ${dataAttributes.box}` + ' ' + packageSort;
              }

              _packageItemBOS.push(packageItem);
            });

            _packageItemBOS?.forEach((packageItem, packageIndex) => {
              const { trackingInfo } = packageItem;
              const packageStatus = resolvePackageStatus(packageItem);
              const packageShippingMethod = resolvePackageShippingMethod(packageItem);
              const routeMaskId = `track-mask-${index}-${packageIndex}`;
              let progressWidth = 0;
              let progressStatus = '';
              switch (packageStatus) {
                case statusEnum[1]:
                  progressWidth = 20;
                  progressStatus = dataAttributes.pendingShipment;
                  break;
                case statusEnum[2]:
                  progressWidth = 40;
                  progressStatus = dataAttributes.shipped;
                  break;
                case statusEnum[3]:
                  progressWidth = 60;
                  progressStatus = dataAttributes.inTransit;
                  break;
                case statusEnum[4]:
                  progressWidth = 80;
                  progressStatus = dataAttributes.outForDelivery;
                  break;
                case statusEnum[5]:
                  progressWidth = 100;
                  progressStatus = dataAttributes.delivered;
                  break;
                default:
                  progressStatus = packageStatus;
                  break;
              }

              // 判断 status 状态是否在 statusEnum 里
              const isStatusValid = Object.values(statusEnum).includes(packageStatus);

              itemHtml += `
                <div class='status-item__content-package-item' data-package-status='${escapeFilterAttr(packageStatus)}' data-package-shipping-method='${escapeFilterAttr(
                packageShippingMethod
              )}'>
                  <div class='status-item__content-package-item-main'>
                    <div class='status-item__content-package-item-info'>
                      <div class='status-item__content-package-item-info-content'>
                        <p class='package-name'>${dataAttributes.package} ${packageIndex + 1}</p>
                        ${
                          packageItem.productStyleName
                            ? `<p> <span>${dataAttributes.contents}:</span> <span> ${escapeHtml(packageItem.productStyleName || '')}</span></p>`
                            : ''
                        }
                        ${
                          packageItem.erpSku
                            ? `<p> <span> SKU: </span> <span> ${escapeHtml(packageItem.erpSku || '')}   <b-tooltip class='track-tooltip' content='${escapeFilterAttr(
                                dataAttributes.skuMark
                              )}'> <span class='sku-mark'>?</span></b-tooltip> </span> </p>`
                            : ''
                        }
                      </div>
                      <div class='status-item__content-package-item-info-content'>
                        <p> 
                          <span>${dataAttributes.status}:</span> 
                          <span> 
                            ${progressStatus || ''}
                          </span>
                        </p>

                        ${
                          packageItem.trackingNumber
                            ? `<p> 
                          <span>${dataAttributes.trackingNumber}:</span>
                          <span> ${
                            packageItem.trackingNumber
                              ? `<a class='track-order-status__link' href='${escapeHtml(packageItem.trackingUrl || '#')}' target='_blank'>${
                                  packageItem.trackingNumber
                                }  </a>`
                              : '-'
                          }

                            ${
                              packageItem.trackingNumber
                                ? `<svg
                              class='track-order-status__link-icon'
                              xmlns='http://www.w3.org/2000/svg'
                              data-tracking-number='${escapeFilterAttr(packageItem.trackingNumber)}'
                              width='16'
                              height='16'
                              viewBox='0 0 16 16'
                              fill='none'
                            >
                              <path d="M4.66683 14H12.6668C13.4302 14 14.0002 13.4013 14.0002 12.6666V4.66665C14.0002 4.48984 13.9299 4.32027 13.8049 4.19524C13.6799 4.07022 13.5103 3.99998 13.3335 3.99998C13.2451 3.99998 13.1603 3.96486 13.0978 3.90235C13.0353 3.83984 13.0002 3.75505 13.0002 3.66665C13.0002 3.57824 13.0353 3.49346 13.0978 3.43094C13.1603 3.36843 13.2451 3.33331 13.3335 3.33331C13.5086 3.33331 13.682 3.3678 13.8437 3.43481C14.0055 3.50181 14.1525 3.60003 14.2763 3.72384C14.4001 3.84765 14.4983 3.99463 14.5653 4.1564C14.6323 4.31817 14.6668 4.49155 14.6668 4.66665V12.6666C14.6668 13.8846 13.8362 14.6666 12.6668 14.6666H4.66683C4.49173 14.6666 4.31835 14.6322 4.15658 14.5652C3.99482 14.4981 3.84783 14.3999 3.72402 14.2761C3.60021 14.1523 3.502 14.0053 3.43499 13.8436C3.36798 13.6818 3.3335 13.5084 3.3335 13.3333C3.33306 13.2895 3.34125 13.2461 3.35759 13.2055C3.37394 13.1649 3.39813 13.1279 3.42877 13.0966C3.45941 13.0654 3.49591 13.0405 3.53619 13.0233C3.57646 13.0061 3.61972 12.9971 3.6635 12.9966C3.70727 12.9962 3.7507 13.0044 3.79131 13.0207C3.83192 13.0371 3.86891 13.0613 3.90017 13.0919C3.93144 13.1226 3.95636 13.1591 3.97351 13.1993C3.99067 13.2396 3.99973 13.2829 4.00016 13.3266C4.00016 13.7013 4.29883 14 4.66683 14ZM2.59283 1.33331H11.4068C12.1028 1.33331 12.6668 1.89731 12.6668 2.59265V11.4066C12.6669 11.5721 12.6344 11.7359 12.5712 11.8888C12.5079 12.0416 12.4152 12.1806 12.2982 12.2976C12.1813 12.4146 12.0424 12.5074 11.8896 12.5707C11.7367 12.6341 11.5729 12.6666 11.4075 12.6666H2.5935C2.42806 12.6667 2.26423 12.6342 2.11137 12.571C1.9585 12.5077 1.81959 12.415 1.70258 12.298C1.58557 12.1811 1.49275 12.0422 1.42942 11.8894C1.36609 11.7366 1.3335 11.5727 1.3335 11.4073V2.59331C1.3335 1.89731 1.8975 1.33331 2.59283 1.33331ZM2.6255 1.99998C2.45965 1.99998 2.30059 2.06586 2.18332 2.18314C2.06605 2.30041 2.00016 2.45946 2.00016 2.62531V11.3746C2.00016 11.72 2.28016 12 2.6255 12H11.3748C11.7202 12 12.0002 11.72 12.0002 11.3746V2.62531C12.0003 2.54317 11.9841 2.46181 11.9527 2.3859C11.9213 2.31 11.8753 2.24102 11.8172 2.18294C11.7591 2.12485 11.6901 2.0788 11.6142 2.0474C11.5383 2.01601 11.457 1.99989 11.3748 1.99998H2.6255ZM6.66683 6.66665V4.33331C6.66683 4.24491 6.70195 4.16012 6.76446 4.09761C6.82697 4.0351 6.91176 3.99998 7.00016 3.99998C7.08857 3.99998 7.17335 4.0351 7.23586 4.09761C7.29838 4.16012 7.3335 4.24491 7.3335 4.33331V6.66665H9.66683C9.75524 6.66665 9.84002 6.70177 9.90253 6.76428C9.96504 6.82679 10.0002 6.91157 10.0002 6.99998C10.0002 7.08839 9.96504 7.17317 9.90253 7.23568C9.84002 7.29819 9.75524 7.33331 9.66683 7.33331H7.3335V9.66665C7.3335 9.75505 7.29838 9.83984 7.23586 9.90235C7.17335 9.96486 7.08857 9.99998 7.00016 9.99998C6.91176 9.99998 6.82697 9.96486 6.76446 9.90235C6.70195 9.83984 6.66683 9.75505 6.66683 9.66665V7.33331H4.3335C4.24509 7.33331 4.16031 7.29819 4.09779 7.23568C4.03528 7.17317 4.00016 7.08839 4.00016 6.99998C4.00016 6.91157 4.03528 6.82679 4.09779 6.76428C4.16031 6.70177 4.24509 6.66665 4.3335 6.66665H6.66683Z" fill="#173317" stroke="#173317" stroke-width="0.3"/>
                            </svg>`
                                : ''
                            } 
                       
                          </span>
                        </p>
                        <p> <span>${dataAttributes.shippingMethod}:</span> <span> ${packageShippingMethod || '-'}</span></p>`
                            : ''
                        }


                        ${
                          packageItem.estimatedShippingDate && packageStatus === statusEnum[1]
                            ? `<p> <span>${dataAttributes.estimatedShippingDate}:</span> <span> ${
                                packageItem.estimatedShippingDate || '-'
                              }</span></p>`
                            : ''
                        }

                        ${
                          packageStatus === statusEnum[1] ||
                          packageStatus === statusEnum[2] ||
                          packageStatus === statusEnum[3] ||
                          packageStatus === statusEnum[4]
                            ? `<p> <span>${dataAttributes.estimatedDeliveryDate}:</span> <span> ${
                                packageItem.estimatedDeliveryDate || '-'
                              }   <b-tooltip class='track-tooltip' content='${escapeFilterAttr(
                                dataAttributes.estimatedDeliveryDateMark
                              )}'> <span class='sku-mark'>?</span></b-tooltip> </span></p>`
                            : ''
                        }

                        ${
                          packageItem.deliveryDate && packageStatus === statusEnum[5]
                            ? `<p> <span>${dataAttributes.deliveryDate}:</span> <span> ${packageItem.deliveryDate || '-'}</span></p>`
                            : ''
                        }

                        ${
                          packageItem.deliverNumber
                            ? `<p> <span>${dataAttributes.deliveryNumber}:</span> <span> #${packageItem.deliverNumber} ${dataAttributes.ofOrVon} ${packageItem.totalNumber}</span></p>`
                            : ''
                        }
                      </div>
                      <div class='package-item-button-box'>
                        <button type='button' class='button package-item-button ${updateLoading ? 'loading disabled ' : ''}'> ${
                dataAttributes.seeDetails
              } </button>
                      </div>
                    </div>
                 
                  </div>

                  <div class='status-item__content-package-item-progress'>
                  ${
                    isStatusValid
                      ? `<div class='progress-bar'>
                      <div class='progress-bar-main'>
                        <div class='progress-bar-status'>
                          <div class='progress-bar-status-item'>
                            <p>${dataAttributes.pendingShipment}</p>
                            <i class='icon-check'>
                              <svg ${
                                progressWidth >= 20 ? 'class="active"' : ''
                              } xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                                <mask id="${routeMaskId}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                  <rect width="24" height="24" fill="#D9D9D9"/>
                                </mask>
                                <g mask="url(#${routeMaskId})">
                                  <path d="M10.5808 16.2538L17.3038 9.53075L16.25 8.47693L10.5808 14.1462L7.73075 11.2962L6.67693 12.35L10.5808 16.2538ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5Z" fill="#8CA914"/>
                                </g>
                              </svg>
                              <svg ${
                                progressWidth >= 20 ? '' : 'class="active"'
                              } xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                                <circle cx="12" cy="12" r="11.5" stroke="#D9D9D9"/>
                              </svg>
                            </i>
                          </div>
                          <div class='progress-bar-status-circle'>
                            <i></i>
                            <i></i>
                            <i></i>
                          </div>
                          <div  class='progress-bar-status-item'>
                            <p>${dataAttributes.shipped}</p>
                            <i class='icon-check'>
                              <svg ${
                                progressWidth >= 40 ? 'class="active"' : ''
                              } xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                                <mask id="${routeMaskId}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                  <rect width="24" height="24" fill="#D9D9D9"/>
                                </mask>
                                <g mask="url(#${routeMaskId})">
                                  <path d="M10.5808 16.2538L17.3038 9.53075L16.25 8.47693L10.5808 14.1462L7.73075 11.2962L6.67693 12.35L10.5808 16.2538ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5Z" fill="#8CA914"/>
                                </g>
                              </svg>
                              <svg ${
                                progressWidth >= 40 ? '' : 'class="active"'
                              } xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                                <circle cx="12" cy="12" r="11.5" stroke="#D9D9D9"/>
                              </svg>
                            </i>
                          </div>
                          <div class='progress-bar-status-circle'>
                            <i></i>
                            <i></i>
                            <i></i>
                          </div>
                          <div class='progress-bar-status-item'>
                            <p>${dataAttributes.inTransit}</p>
                            <i class='icon-check'>
                              <svg ${
                                progressWidth >= 60 ? 'class="active"' : ''
                              } xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                                <mask id="${routeMaskId}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                  <rect width="24" height="24" fill="#D9D9D9"/>
                                </mask>
                                <g mask="url(#${routeMaskId})">
                                  <path d="M10.5808 16.2538L17.3038 9.53075L16.25 8.47693L10.5808 14.1462L7.73075 11.2962L6.67693 12.35L10.5808 16.2538ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5Z" fill="#8CA914"/>
                                </g>
                              </svg>
                              <svg ${
                                progressWidth >= 60 ? '' : 'class="active"'
                              } xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                                <circle cx="12" cy="12" r="11.5" stroke="#D9D9D9"/>
                              </svg>
                            </i>
                          </div>
                          <div class='progress-bar-status-circle'>
                            <i></i>
                            <i></i>
                            <i></i>
                          </div>
                          <div class='progress-bar-status-item'>
                            <p>${dataAttributes.outForDelivery}</p>
                            <i class='icon-check'>
                              <svg ${
                                progressWidth >= 80 ? 'class="active"' : ''
                              } xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                                <mask id="${routeMaskId}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                  <rect width="24" height="24" fill="#D9D9D9"/>
                                </mask>
                                <g mask="url(#${routeMaskId})">
                                  <path d="M10.5808 16.2538L17.3038 9.53075L16.25 8.47693L10.5808 14.1462L7.73075 11.2962L6.67693 12.35L10.5808 16.2538ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5Z" fill="#8CA914"/>
                                </g>
                              </svg>
                              <svg ${
                                progressWidth >= 80 ? '' : 'class="active"'
                              } xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                                <circle cx="12" cy="12" r="11.5" stroke="#D9D9D9"/>
                              </svg>
                            </i>
                          </div>
                          <div class='progress-bar-status-circle'>
                            <i></i>
                            <i></i>
                            <i></i>
                          </div>
                          <div class='progress-bar-status-item'>
                            <p>${dataAttributes.delivered}</p>
                            <i class='icon-check'>
                              <svg ${
                                progressWidth >= 100 ? 'class="active"' : ''
                              } xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                                <mask id="${routeMaskId}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                  <rect width="24" height="24" fill="#D9D9D9"/>
                                </mask>
                                <g mask="url(#${routeMaskId})">
                                  <path d="M10.5808 16.2538L17.3038 9.53075L16.25 8.47693L10.5808 14.1462L7.73075 11.2962L6.67693 12.35L10.5808 16.2538ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5Z" fill="#8CA914"/>
                                </g>
                              </svg>
                              <svg ${
                                progressWidth >= 100 ? '' : 'class="active"'
                              } xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                                <circle cx="12" cy="12" r="11.5" stroke="#D9D9D9"/>
                              </svg>
                            </i>
                          </div>
                        </div>
                        <div class='progress-bar-line'>
                          <i style='width: ${progressWidth}%'></i>
                        </div>
                      </div>

                     ${
                       packageStatus === statusEnum[1] && !trackingInfo?.routeList?.length
                         ? `<div class="progress-bar-err">${dataAttributes.barErr}</div>`
                         : ''
                     }
                    </div>`
                      : ''
                  }

                   ${
                     trackingInfo?.routeList?.length > 0
                       ? `<div class='tracking-information'>
                      <h3>${dataAttributes.orderTrackingDetails}</h3>
                      <div class='tracking-information-box'>
                        ${trackingInfo?.routeList
                          ?.map(
                            (item) => `
                          <div class='tracking-information-item'>
                            <div class='tracking-information-item-time'>
                              <p>${splitDateTime(item?.createTime)?.date}</p>
                              <p>${splitDateTime(item?.createTime)?.time}</p>
                            </div>

                            <div class='tracking-information-item-content'>
                            <p class='message'>${escapeHtml(item?.message || '')}</p>
                            <p>${escapeHtml(item?.remark || '')}</p>
                            <p>${escapeHtml(item?.location || '')}</p>
                            </div>
                          </div>
                        `
                          )
                          .join('')}
                      </div>
                    </div>`
                       : ''
                   }

                  </div>  
                </div>
              `;
            });
          }

          itemHtml += `</div>`;

          // 设置status-item的HTML内容
          statusItem.innerHTML = itemHtml;

          // 添加到容器中
          statusItemsContainer.appendChild(statusItem);

          // 添加按钮点击事件监听器
          const packageButtons = statusItem.querySelectorAll('.package-item-button');
          packageButtons.forEach((button) => {
            button.addEventListener('click', function () {
              // 判断是否有loading类名
              if (this.classList.contains('loading')) {
                return;
              }

              // 获取对应的进度条元素
              const progressContainer = this.closest('.status-item__content-package-item-main').nextElementSibling;

              if (!progressContainer) {
                return;
              }

              // 切换显示/隐藏状态
              const isVisible = progressContainer.style.height === 'auto';

              if (isVisible) {
                // 隐藏进度条
                progressContainer.style.height = '0';
                progressContainer.style.opacity = '0';
                progressContainer.style.padding = '0';
                progressContainer.style.border = 'none';
                this.textContent = dataAttributes.seeDetails;
              } else {
                // 判断屏幕大小 是否移动端
                const isMobile = window.innerWidth <= 768;

                if (isMobile) {
                  // 移动端 显示进度条
                  progressContainer.style.height = 'auto';
                  progressContainer.style.padding = '20px';
                  progressContainer.style.border = '1px solid #ebe9e7';
                  progressContainer.style.opacity = '1';
                  this.textContent = dataAttributes.close;
                } else {
                  // 非移动端 显示进度条
                  progressContainer.style.height = 'auto';
                  progressContainer.style.padding = '20px 75px 50px';
                  progressContainer.style.border = '1px solid #ebe9e7';
                  progressContainer.style.opacity = '1';
                  this.textContent = dataAttributes.close;
                }
              }
            });

            // 初始化隐藏进度条
            const progressContainer = button.closest('.status-item__content-package-item-main').nextElementSibling;

            if (!progressContainer) {
              return;
            }

            progressContainer.style.height = '0';
            progressContainer.style.opacity = '0';
            progressContainer.style.padding = '0';
            progressContainer.style.border = 'none';
            progressContainer.style.overflow = 'hidden';
            progressContainer.style.transition = 'opacity 0.5s ease-in-out, height 0.5s ease-in-out';
          });

          const productSvgList = statusItem.querySelectorAll('.status-item__content-product-svg');
          productSvgList.forEach((button) => {
            button.addEventListener('click', function () {
              // 获取对应的进度条元素
              const statusContainer = this.closest('.status-item__content-product').nextElementSibling;

              if (!statusContainer) {
                return;
              }

              // 切换显示/隐藏状态
              const isVisible = statusContainer.style.height === 'auto';

              if (isVisible) {
                // 隐藏进度条
                statusContainer.style.height = '0';
                statusContainer.style.opacity = '0';
                this.style.transform = 'rotate(-180deg)';
                this.style.transition = 'all 0.5s ease-in-out';
              } else {
                // 显示进度条
                statusContainer.style.height = 'auto';
                statusContainer.style.opacity = '1';
                this.style.transform = 'rotate(0deg)';
                this.style.transition = 'all 0.5s ease-in-out';
              }
            });

            // 初始化隐藏进度条
            const statusContainer = button.closest('.status-item__content-product').nextElementSibling;

            if (!statusContainer) {
              return;
            }

            statusContainer.style.height = 'auto';
            statusContainer.style.opacity = '1';
            statusContainer.style.overflow = 'hidden';
            statusContainer.style.transition = 'opacity 0.5s ease-in-out, height 0.5s ease-in-out';
          });

          // 点击复制trackingNumber功能
          setupTrackingNumberCopy();
          } catch (error) {
            console.error('[track-order-status] render item failed:', index, error);
          }
        });

        initPackageFilters(result);
      } else if (statusItemsContainer) {
        statusItemsContainer.innerHTML = '';
        initPackageFilters(result);
      }
    }

    function copyTrackingNumber() {
      // 获取父元素中的trackingNumber
      let trackingNumber = this.dataset.trackingNumber;
      if (trackingNumber) {
        trackingNumber = trackingNumber.trim();

        // 使用Clipboard API复制文本
        navigator.clipboard
          .writeText(trackingNumber)
          .then(() => {
            // 复制成功提示
            window.BMessage.success({ content: dataAttributes.copy });
          })
          .catch((err) => {
            // 复制失败处理
            console.error('Failed to copy tracking number:', err);
            // window.BMessage.error({ content: 'Failed to copy tracking number' });
          });
      }
    }

    // 点击复制trackingNumber功能
    function setupTrackingNumberCopy() {
      // 为所有带有track-order-status__link-icon类的SVG添加点击事件监听器
      const copyIcons = document.querySelectorAll('.track-order-status__link-icon');

      copyIcons.forEach((icon) => {
        icon.removeEventListener('click', copyTrackingNumber);
        icon.addEventListener('click', copyTrackingNumber);
      });
    }

    const collectionQaFaqBoxEel = document.querySelector('.collection-qa-faq-box');
    if (collectionQaFaqBoxEel) {
      collectionQaFaqBoxEel.style.display = 'none';
    }

    // 表单提交处理
    trackOrderForm.addEventListener('submit', async function (e) {
      e.preventDefault();

      const trackOrderStatusButton = document.querySelector('.track-order-status__button');

      // 判断 trackOrderStatusButton 上是否有 loading 类
      if (trackOrderStatusButton.classList.contains('loading')) {
        return;
      }

      // 获取表单值
      let orderNumber = orderNumberInput?.value?.trim();
      const email = emailInput?.value?.trim();

      // 这里可以添加表单验证逻辑
      if (!orderNumber) {
        orderNumberInput.focus();
        return;
      }

      if (!email) {
        emailInput.focus();
        return;
      }

      // 邮箱格式验证
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email)) {
        emailInput.focus();
        return;
      }

      // 加一个自定加 # 逻辑
      if (!orderNumber.startsWith('#')) {
        orderNumber = `#${orderNumber}`;
      }

      // #FZ-TEST1273 测试店铺  #VERNAL-US21072 us #VERNAL-UK4215 uk #VERNAL-DE18713 de #VERNAL-JP2193 jp
      // 根据单号判断是哪个店铺的订单
      if (orderNumber.startsWith('#FZ-TEST')) {
        ShopKey = 'test';
      } else if (orderNumber.startsWith('#VERNAL-US')) {
        ShopKey = 'us';
      } else if (orderNumber.startsWith('#VERNAL-UK')) {
        ShopKey = 'uk';
      } else if (orderNumber.startsWith('#VERNAL-DE')) {
        ShopKey = 'de';
      } else if (orderNumber.startsWith('#VERNAL-JP')) {
        ShopKey = 'jp';
      }

      const shopId = vernalShopIdMap[ShopKey] ?? '132711809701380096';
      const requestURL = `${baseURL}/order/tracking-info/getByOrderName?shopId=${shopId}&orderName=${encodeURIComponent(
        orderNumber
      )}&email=${email}`;
      const requestURL2 = `${baseURL2}/yfs-cdm/fulfillment/getShopifyDeliverOrderInfo?orderName=${encodeURIComponent(
        orderNumber
      )}&email=${encodeURIComponent(email)}`;

      // 加loading
      trackOrderStatusButton.classList.add('loading');
      trackOrderStatusButton.classList.add('disabled');

      // 主数据
      const metaData = { shopifyMetaProductVO: {} };

      // 数据处理和调用更新函数
      function updateUI(metaData, type) {
        if (metaData.shopifyMetaProductVO && metaData.shopifyMetaProductVO?.sellerOrderId) {
          // 用 trackingNumber 找到对应 trackingInfoList
          metaData.trackingInfoList?.forEach((item) => {
            metaData.shopifyMetaProductVO?.items?.forEach((itemMock) => {
              itemMock.packageItemBOS?.forEach((packageItemMock) => {
                const packageTrackingNumber = String(packageItemMock.trackingNumber || '').trim();
                const trackingNumber = String(item.trackingNum || '').trim();

                if (packageTrackingNumber && trackingNumber && packageTrackingNumber === trackingNumber) {
                  const trackingInfo = item;
                  packageItemMock.trackingInfo = trackingInfo;

                  if (!packageItemMock.status && trackingInfo?.status) {
                    packageItemMock.status = trackingInfo.status;
                  }

                  if (!packageItemMock.shippingMethod && trackingInfo?.trackingCompany) {
                    packageItemMock.shippingMethod = trackingInfo.trackingCompany;
                  }
                }
              });
            });
          });
        }

        // 没有 meta的情况
        const hasPackageData = countPackagesInVO(metaData.shopifyMetaProductVO) > 0;

        if (
          !hasPackageData &&
          metaData.shopifyMetaProductVO?.sellerOrderId === undefined &&
          metaData.shopifyOrderV2VO &&
          metaData.shopifyOrderV2VO?.order?.name &&
          !metaData.trackingInfoList?.length &&
          !metaData.fulfillmentList?.length
        ) {
          // 说明是没有发货状态的情况 需要处理一下
          const { order, shopifyProductVO } = metaData.shopifyOrderV2VO;
          metaData.shopifyMetaProductVO.sellerOrderId = order.name;
          metaData.shopifyMetaProductVO.orderDate = splitDateTime(order.created_at).date;
          metaData.shopifyMetaProductVO.buyerEmail = order.email || '';
          metaData.shopifyMetaProductVO.orderStatus = 'Pending Shipment';
          metaData.shopifyMetaProductVO.shippingAddress = `${order.shipping_address.company || ''} ${
            order.shipping_address.address1 || ''
          } ${order.shipping_address.address2 || ''} ${order.shipping_address.address3 || ''}  ${order.shipping_address.city || ''}  ${
            order.shipping_address.province || ''
          } ${order.shipping_address.zip || ''} ${order.shipping_address.country || ''}`;
          metaData.shopifyMetaProductVO.noDelivery = true;

          metaData.shopifyMetaProductVO.items = order.line_items
            .filter((item) => item.fulfillable_quantity > 0)
            .map((item) => {
              variant_id = item.variant_id || '';

              const product = shopifyProductVO?.product?.find((product) => product.variants.some((variant) => variant.id === variant_id));

              return {
                productImg: product?.images?.[0]?.src || '',
                productName: item.title || '',
                quantity: item.fulfillable_quantity,
                productOptionName: item.variant_title || '',
                productNumberOfBoxes: 0,
              };
            });
        }

        // 如果 shopifyMetaProductVO 都不存在 trackingInfoList fulfillmentList 存在 说明是历史数据
        if (
          !hasPackageData &&
          metaData.trackingInfoList?.length > 0 &&
          metaData.fulfillmentList?.length > 0 &&
          metaData.shopifyMetaProductVO?.sellerOrderId === undefined
        ) {
          metaData.shopifyMetaProductVO.items = metaData.fulfillmentList.map((item) => {
            const { productName, variant } = splitProductNameAndVariant(item?.orderItemList?.[0]?.name || '');
            const productOptionName = variant || '';
            const trackingNumber = item?.trackingNum || '';

            const trackingInfo = metaData.trackingInfoList.find((item) => item.trackingNum === trackingNumber && trackingNumber);

            return {
              productImg: item?.orderItemList?.[0]?.imageSrc || '',
              productName: productName,
              quantity: item?.orderItemList?.[0]?.quantity || 0,
              productOptionName: productOptionName,
              productNumberOfBoxes: 0,
              packageItemBOS: [
                {
                  trackingNumber: trackingNumber,
                  trackingUrl: trackingInfo?.trackingUrl || '',
                  status: trackingInfo?.status || '',
                  shippingMethod: trackingInfo?.trackingCompany || '',
                  trackingInfo: trackingInfo,
                },
              ],
            };
          });
        }

        // 订单存在，更新页面内容
        // 使用mock数据填充结果信息
        updateResultContent(metaData.shopifyMetaProductVO);
      }

      Promise.all([
        fetch(requestURL)
          .then((response) => response.json())
          .catch(() => null),
        fetch(requestURL2)
          .then((response) => response.json())
          .catch(() => null),
      ])
        .then(([mainRes, secondaryRes]) => {
          const hasMainOrder = mainRes?.code === 0;
          const hasSecondaryOrder = String(secondaryRes?.code) === '10000' && secondaryRes?.data?.sellerOrderId;

          if (!hasMainOrder && !hasSecondaryOrder) {
            window.BMessage.error({ content: dataAttributes.orderNotFound || 'Order not found' });
            return;
          }

          const searchSection = document.querySelector('.track-order-status__search');
          const resultSection = document.querySelector('.track-order-status__result');

          searchSection.classList.add('hidden');
          resultSection.classList.add('active');

          if (collectionQaFaqBoxEel) {
            collectionQaFaqBoxEel.style.display = 'block';
          }

          metaData.shopifyMetaProductVO = {};
          metaData.trackingInfoList = [];
          metaData.shopifyOrderV2VO = {};
          metaData.fulfillmentList = [];

          if (hasMainOrder) {
            metaData.trackingInfoList = mainRes.data.trackingInfoList || [];
            metaData.shopifyOrderV2VO = mainRes.data.shopifyOrderV2VO || {};
            metaData.fulfillmentList = mainRes.data.fulfillmentList || [];
          }

          metaData.shopifyMetaProductVO = buildShopifyMetaProductVO(mainRes, secondaryRes);

          updateUI(metaData);

          const backToSearch = document.querySelector('.track-order-status__result-track');
          if (backToSearch && backToSearch.dataset.bound !== 'true') {
            backToSearch.addEventListener('click', () => {
              searchSection.classList.remove('hidden');
              resultSection.classList.remove('active');
            });
            backToSearch.dataset.bound = 'true';
          }
        })
        .finally(() => {
          trackOrderStatusButton.classList.remove('loading');
          trackOrderStatusButton.classList.remove('disabled');
          updateLoading = false;
        });
    });

    // 页面加载时检查URL参数并自动查询
    initPackageFilterDropdownEvents();
    autoFillAndSubmitForm();
  });

  } catch(e) { console.error(e); }
})();
})();
